import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

export async function zoomTo(args: any, context: ToolContext): Promise<ToolResult> {
	const { threeInstance, publish } = context;
	if (!threeInstance) {
		return { success: false, error: 'Three.js instance not initialized' };
	}

	const { target } = args;
	if (typeof target !== 'string') {
		return { success: false, error: 'target parameter must be a string' };
	}

	if (target === 'all') {
		if (typeof threeInstance.zoomToAll !== 'function') {
			return {
				success: false,
				errorCode: 'NOT_READY',
				error: 'Camera controls are still initializing. Please wait a moment and try again.',
				recoveryHint: 'Wait 1-2 seconds then retry zoom_to.'
			};
		}
		await threeInstance.zoomToAll();
	} else {
		if (typeof threeInstance.zoomToIsland !== 'function') {
			return {
				success: false,
				errorCode: 'NOT_READY',
				error: 'Camera controls are still initializing. Please wait a moment and try again.',
				recoveryHint: 'Wait 1-2 seconds then retry zoom_to.'
			};
		}
		await threeInstance.zoomToIsland(target);
	}

	publish('camera', 'change', {
		ref: 'zoom',
		old: null,
		new: { target }
	});

	return { success: true, data: { target }};
}
